import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./react-query";
import { AlertProvider } from "./context/AlertContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ErrorAlert, SuccessAlert } from "./components";
import ConfirmAlert from "./components/Alert/ConfirmAlert";
import RoutesWrapper from "./routes";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AlertProvider>
        <RoutesWrapper />
        <ToastContainer />
        <ErrorAlert autoClose={false} />
        <SuccessAlert autoClose={false} />
        <ConfirmAlert autoClose={false} />
      </AlertProvider>
    </QueryClientProvider>
  );
}

export default App;
